var _path, _circle, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMultipleProduct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95184 14.9965C5.96711 14.9965 3.98237 14.999 1.99764 14.9946C1.56414 14.9934 1.19136 14.8041 0.848931 14.543C0.394792 14.1964 0.145258 13.7179 0.0129017 13.1645C-0.00106249 13.1058 0.00136606 13.0415 0.00136606 12.9797C0.000151785 9.33267 -0.00166963 5.68505 0.00318748 2.03743C0.00318748 1.60708 0.181079 1.22858 0.43122 0.892548C0.908431 0.251715 1.55382 -0.00124458 2.32549 4.6019e-06C6.14379 0.00625053 9.96208 -0.00561673 13.7798 0.00812431C14.8981 0.0124965 15.8003 0.786992 15.9509 1.94249C15.9746 2.12487 15.9952 2.31037 15.9952 2.494C15.9976 5.89179 16.0061 9.28895 15.9922 12.6867C15.9879 13.7948 15.3686 14.6124 14.3438 14.9353C14.1695 14.9902 13.9765 14.9965 13.7919 14.9971C11.8448 15.0015 9.89772 14.9996 7.95124 14.9996V14.9965H7.95184ZM10.5431 1.50277V1.75636C10.5431 2.91248 10.5437 4.06798 10.5431 5.2241C10.5431 5.67693 10.2268 6.00109 9.78601 6.00172C8.58934 6.00297 7.39206 6.00234 6.19539 6.00172C5.73943 6.00172 5.45286 5.70254 5.45226 5.22722C5.45165 4.06361 5.45226 2.89999 5.45226 1.73575C5.45226 1.6608 5.45226 1.58647 5.45226 1.50402C4.31994 1.50402 3.21495 1.4984 2.10935 1.50715C1.75114 1.51027 1.45303 1.85817 1.45243 2.23542C1.45182 5.74251 1.45182 9.24897 1.45243 12.7561C1.45243 13.1858 1.7645 13.4993 2.18889 13.4993C6.03754 13.4993 9.88558 13.4956 13.7342 13.505C14.1683 13.5062 14.5423 13.1664 14.5423 12.6774C14.5435 9.22524 14.5484 5.77312 14.5375 2.32099C14.5357 1.80008 14.2691 1.52276 13.7749 1.51027C12.7082 1.48404 11.6402 1.50215 10.5431 1.50215V1.50277ZM9.08355 1.51652H6.91971V4.48895H9.08355V1.51589V1.51652Z",
    fill: "#222222"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 13.5,
    r: 4.5,
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05113 13.7819C6.89507 13.7819 6.76855 13.6554 6.76855 13.4993C6.76855 13.3433 6.89507 13.2167 7.05113 13.2167H9.9122C10.0683 13.2167 10.1948 13.3433 10.1948 13.4993C10.1948 13.6554 10.0683 13.7819 9.9122 13.7819H7.05113ZM8.18143 12.0688C8.18143 11.903 8.31585 11.7686 8.48166 11.7686C8.64748 11.7686 8.7819 11.903 8.7819 12.0688V14.9299C8.7819 15.0957 8.64748 15.2301 8.48166 15.2301C8.31585 15.2301 8.18143 15.0957 8.18143 14.9299V12.0688Z",
    fill: "url(#paint0_linear_188_22042)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_188_22042",
    x1: 6.9951,
    y1: 15.6023,
    x2: 10.8268,
    y2: 14.1714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMultipleProduct);
export default __webpack_public_path__ + "static/media/icon-multiple-product.d9ab24a394020ba506460e92d7406435.svg";
export { ForwardRef as ReactComponent };